import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDrupalComponent } from './simple-icons-drupal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDrupalComponent ],
    exports:      [ SimpleIconsDrupalComponent ],
    bootstrap:    []
})
export class SimpleIconsDrupalModule {}
